const hierarchy = [
  { value: "ItemArea", description: "ItemArea" },
  { value: "MacroArea", description: "MacroArea" },
];

export default hierarchy;
